import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withSnackbar } from 'notistack';
import { concat as _concat } from 'lodash';

import 'ag-grid-community/dist/styles/ag-grid.css'
import 'ag-grid-community/dist/styles/ag-theme-balham.css';
import Grid from '@material-ui/core/Grid';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { withStyles } from '@material-ui/core/styles';
import { Button, Typography, LinearProgress, Dialog, InputLabel } from '@material-ui/core';

import mapStateToProps from 'reducers/actions/stateToProps';
import { SubscriberHandler } from 'chits-data/dist';
import { formatSubcriberName } from 'components/mapper/objectMapping';

import './Subscriber.css'
import { SubscriberStyle } from './SubscriberStyle';

let classes = null;
let defaultSubscriber = {
	_id: 'unknown',
	fname: 'Please select',
	lname: 'a contact',
	isd_code: '',
	cell: ''
};
let _formatter = (sub) => formatSubcriberName(sub);

class AssignSubscriber extends Component {
	constructor(props) {
		super(props)
		classes = this.props.classes;
		this._handler = new SubscriberHandler();
		this.handleFieldAssignSubscriberChange = this.handleFieldAssignSubscriberChange.bind(this)
	}

	state = {
		actionInProgress: {
			openLinearLoading: false,
			disableActionButton: false,
			disableLinkAction: true
		},
		sqlErrorMessage: '',
		mode: this.props.mode,
		assignSubscriberId: defaultSubscriber._id,
		accounts: [],
		transactions: [],
		subscribers: [defaultSubscriber]
	};

	componentDidMount() {
		this._handler.componentDidMount();
		this.handleGetAccounts(true);
	}

	componentWillUnmount() {
		this._handler.componentWillUnmount();
	}


	handleGetAccounts = async (refresh = false) => {
		let request = Promise.resolve(refresh);
		request
			.then((condition) => {
				return this._handler.getSubscribersCached(condition);
			})
			.then((data) => {
				let otherSubscribers = data.filter((sub, index) => {
					let { chitfunds } = sub;
					return !(chitfunds && chitfunds.includes(this.props.account._id));
				});
				// console.log('remaining subscribers to pick are: ', otherSubscribers)

				this.setState({ subscribers: _concat(defaultSubscriber, otherSubscribers) })
			})
			.catch((err) => {
				console.error('error while fetching accounts:' + err.message);
			})
	}

	handleFieldAssignSubscriberChange(e) {
		let _actionInProgress = this.state.actionInProgress;
		_actionInProgress.disableLinkAction = (e.target.value === 'unknown')
		this.setState({
			assignSubscriberId: e.target.value,
			actionInProgress: _actionInProgress
		});
	}

	handleAssignSubscriber = async () => {
		let matchingSub = this.state.subscribers
			.filter((sub) => sub._id === this.state.assignSubscriberId)[0];
		let subscriberName = formatSubcriberName(matchingSub, false);
		this._handler.assignSubscriberToChitfund(
			this.state.assignSubscriberId,
			subscriberName,
			this.props.account._id,
			this.props.subscriber.index,
			this.props.subscriber.name
		).then((resp) => {
				this.props.onSubmit();
			}).catch((err) => {
				this.props.onError();
			})
	}

	/**
	 * Render UI components
	 */

	renderFormTitle() {
		let label = 'Link a contact to [' + this.props.subscriber.name + ']';
		return (
			<Grid item md={12} lg={12} xs={12} style={{ marginBottom: "5px" }}>
				<Typography align="center">
					{label}
				</Typography>
				{/* <Typography variant="h5" align="center">
					{this.props.account.name}
				</Typography> */}
			</Grid>
		)
	}

	renderFormCopyMoveAccount() {
		// let last = Session.get(SESSION_KEYS.LAST_LINK_ACCOUNT);
		// if (!last) {
		// 	last = 'unknown';
		// }
		return (
			<Grid item md={12} sm={12} xs={12}>
				<div className={classes.assignSubscriberSelectContaier}>
					{/* <InputLabel>Select Contact To {this.props.mode === 'assign' ? 'Assign' : 'Unassign'}:</InputLabel> */}
					<br />
					<br />
					<Select
						name="select-link-account"
						value={this.state.assignSubscriberId}
						onChange={this.handleFieldAssignSubscriberChange}
						className={'assign-subscriber-select-width'}>
						{this.state.subscribers.map((sub, index) => {
							return (
								<MenuItem
									key={`account-${sub._id}`}
									value={sub._id}>
									{_formatter(sub)}
								</MenuItem>
							);
						})}
					</Select>
				</div>
			</Grid>
		)
	}

	renderActions() {
		return (
			<div className={classes.newAccountModalActions} style={{ padding: '4px' }}>
				<Button
					variant="contained"
					color="primary"
					className={classes.button}
					onClick={() => this.props.onCancel()}>
					Cancel
				</Button>
				{this.props.mode === 'assign' && <Button
					variant="contained"
					color="secondary"
					className={classes.button}
					disabled={this.state.actionInProgress.disableLinkAction}
					onClick={this.handleAssignSubscriber}>
					Link
				</Button>}
			</div>
		)
	}

	renderLinearLoader() {
		return (
			this.state.actionInProgress.openLinearLoading &&
			<LinearProgress color="primary" variant="query" />
		)
	}

	render() {
		return (
			<Dialog
				open={this.props.display}
				onClose={() => { }}
				styles={{ modal: { padding: 0 } }} >
				<Grid container className={classes.newAccountModal}>
					{this.renderFormTitle()}
					{this.renderFormCopyMoveAccount()}
				</Grid>
				<br />
				<Grid container className={classes.newAccountModalActions}>
					{this.renderActions()}
					{this.renderLinearLoader()}
				</Grid>
			</Dialog>
		);
	}
}

AssignSubscriber.propTypes = {
	classes: PropTypes.object.isRequired,
	display: PropTypes.bool.isRequired,
	onCancel: PropTypes.func.isRequired,
	onSubmit: PropTypes.func.isRequired,
	onError: PropTypes.func.isRequired,
	// tranTypes: PropTypes.array.isRequired,
	subscriber: PropTypes.object.isRequired,
	account: PropTypes.object.isRequired,
	// isCredit: PropTypes.bool.isRequired,
	//Needed for update transaction
	mode: PropTypes.string.isRequired,
	// accountLineUp: PropTypes.array.isRequired,
	// transactions: PropTypes.array.isRequired,
};

export default connect(mapStateToProps)(withSnackbar(withStyles(SubscriberStyle)(AssignSubscriber)));
